import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerticalLayout from "components/VerticalLayout";
import HorizontalLayout from "components/HorizontalLayout";
import {useEffect} from "react";
import axios from "axios";
import { SECURITY_KEY, BASE_URL } from "../../global";
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { getTutorAuthToken, syncTutorAdminFlag, isAdminMode, getViewAsTutorKey } from "../../common/auth/tutor-admin-auth"


//constants
import { layoutTypes } from "../../constants/layout";
import { AuthenticatedPlainLayout } from "../../components/AuthenticatedPlainLayout/AuthenticatedPlainLayout"
import PaymentHoldNotice from "../../components/PaymentHoldNotice"

const Authmiddleware = (props) => {

  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }));

  const getLayout = (layoutType) => {
    let Layout = VerticalLayout;
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout;
        break;
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout;
        break;
      default:
        break;
    }

    if(props.layout?.plainLayout) {
      Layout = AuthenticatedPlainLayout
    }

    return Layout;
  };

  const Layout = getLayout(layoutType);


  // const jwt_token = JSON.parse(localStorage.getItem('jwt-token')) || null;
  const navigate = useNavigate();

  const authUser = getTutorAuthToken();
//   console.log(tutor_key);
// console.log(tutor_key.pk_tut_key);
 useEffect(() => {
    if (authUser && authUser != "" && authUser != null) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${authUser}` 
      axios.get(BASE_URL+'tutorlogin/checkUser').then(responseTutor => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
           
              if (responseTutor.data.length > 0) {
                    if (responseTutor.data[0]['pk_tut_key'] !== '') {
                      syncTutorAdminFlag(responseTutor.data[0])
                      localStorage.setItem( "cent_key",  responseTutor.data[0]["pk_cent_key"] )
                      if (!isAdminMode() || !getViewAsTutorKey()) {
                        localStorage.setItem( "tut_key",  responseTutor.data[0]["pk_tut_key"])
                      }
                      localStorage.setItem( "is_trial",  responseTutor.data[0]["cent_is_trial_account"])
                      
                  } else {
                    localStorage.clear();
                    <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
                  }

              }else{
                localStorage.clear();
                <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
              }
            
        })
        .catch(error => {
           console.log(error)
          if ((error?.response?.status === 403 || error?.response?.status === 401)) {
            toast.error("Your authentication has expired. Please log in again.", {
              autoClose: 3000, // 3 seconds in this example
              onClose: () => {
                localStorage.clear();
                navigate("/login");
              },
            })
          }

          // if(error){
          //   localStorage.clear();
          // <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
          // }
          
        });


    }
    else{
      localStorage.clear();
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    }
   

}, [props.children]);

//console.log('check');

  if (!localStorage.getItem("authUser")) {
    //console.log('checked');
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return (
    <React.Fragment>
      <PaymentHoldNotice />
      <Layout>{props.children}</Layout>
    </React.Fragment>);
};

export default Authmiddleware;
